import { createApi } from '@reduxjs/toolkit/query/react'
import { staggeredBaseQueryWithBailOut } from '../libs/services'
import { unversionedApiUrl } from './common'
import {
	ClinicalValueAlertThresholds,
	SystemInputAlert,
} from '../model/inputalert'
import { Id } from '../model/model'

const INPUT_ALERTS_TAG = 'inputAlerts'

interface CreateInputAlertsPayload {
	sph?: ClinicalValueAlertThresholds
	cyl?: ClinicalValueAlertThresholds
	axis?: ClinicalValueAlertThresholds
	iop?: ClinicalValueAlertThresholds
	legalEntityId?: Id
}

export const systemInputAlertsApi = createApi({
	reducerPath: 'systemInputAlertsApi',
	tagTypes: [INPUT_ALERTS_TAG],
	baseQuery: staggeredBaseQueryWithBailOut(unversionedApiUrl),
	endpoints: builder => ({
		getSystemInputAlerts: builder.query<
			SystemInputAlert | null,
			string | undefined
		>({
			query: legalEntityId => ({
				url: `/v1/systeminputalerts${
					legalEntityId ? `?legalEntityId=${legalEntityId}` : ''
				}`,
				method: 'GET',
			}),
			providesTags: [INPUT_ALERTS_TAG],
		}),
		createSystemInputAlerts: builder.mutation<
			SystemInputAlert,
			CreateInputAlertsPayload
		>({
			query: body => ({
				url: '/v1/systeminputalerts',
				method: 'POST',
				body,
			}),
			invalidatesTags: [INPUT_ALERTS_TAG],
		}),
		updateSystemInputAlerts: builder.mutation<
			SystemInputAlert,
			{ id: string; body: CreateInputAlertsPayload }
		>({
			query: ({ id, body }) => ({
				url: `/v1/systeminputalerts/${id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: [INPUT_ALERTS_TAG],
		}),
	}),
})

export const {
	useGetSystemInputAlertsQuery,
	useCreateSystemInputAlertsMutation,
	useUpdateSystemInputAlertsMutation,
} = systemInputAlertsApi
